import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Top: 0 takes us all the way back to the top of the page
  // Behavior: smooth keeps it smooth!
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <button
      type="button"
      className={clsx('scroll-to-top scroll-to-target', { 'd-none': isVisible })}
      onClick={scrollToTop}
      tabIndex={0}
      aria-label="Scroll to top">
      <span className="icon icon-arrow-top-right" />
    </button>
  );
}
